import React from "react"
import { connect } from "react-redux"
import BootstrapToggle from "react-bootstrap-toggle";
import {hasBeenFilled} from "../../../../helpers/dynamicFormHelper";
import translations from "../../../../translations";


interface PropsType {
  value: boolean,
  fieldName: string,
  disabled: boolean,
  onChange: any,
  language: string
}

const BasicSwitch = (props: PropsType) => {
  const {
    value,
    onChange,
    fieldName,
    disabled,
    language
  } = props;

  return (
    <BootstrapToggle
      id={fieldName}
      name={fieldName}
      onClick={(state) => onChange(state)}
      on={translations('onSearchFilters', language)}
      onClassName="basic-switch-routine"
      off={translations('offSearchFilters', language)}
      offClassName="basic-switch-ondemand"
      handleClassName="container-basic-switch"
      active={value}
      height="28px"
      width="147px"
      disabled={disabled && hasBeenFilled(value)}
    />
  );
};

const mapStateToProps = (state) => ({
  language: state.application.appParameters.language
})

export default connect(mapStateToProps)(BasicSwitch)
